import { Type } from 'class-transformer';

export default class FinancialInformationOccurrenceModel {
  observacao!: string;

  @Type(() => Date)
  data!: Date;
}
